export default __webpack_public_path__ + "static/media/jc_logo.f13fb5e0.svg";